<template>
  <div>
   <p class="container topnews">
     {{toparticle.title}}
   </p>
   <div class="index-news index-hot">
        <div class="container">
            <div class="box clearfix">
                <div class="box-item" style="width:709px">
                    <el-carousel height="413px"  :interval="5000">
                        <el-carousel-item v-for="(article , index) in articles" :key="index">
                            <a :href="`/news/info/${article.plateid}/${article._id}`">
                            <img :src="`${global.remoteIp}/uploads/${article.picsrc}`" height="413px"/></a>
                            <div class="pictitle">{{article.title}}</div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="box-item" style="width:491px">
                    <div class="inner titleChange">
                        <div class="title-box clearfix">
                            <div class="list tztbiao">
                                <ul class="clearfix">
                                    <li>&nbsp;&nbsp;通知</li>
                                </ul>
                            </div>
                            <div class="linebox"></div>
                        </div>
                        <div class="newsList">

                            <!--工作动态-->
                            <div class="child" style="display: block;">

                                <ul v-if="Groups[0]">
                                    <li class="clearfix newbefore" v-for="(article , index) in  Groups[0].articles" :key="index" ><span class="date">{{article.addtime.slice(0,10)}}</span>
                                        <div class="title"><router-link
                                                :to="`/news/info/${article.plateid}/${article._id}`">{{article.title}}</router-link></div>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  components: {},
  props: {
    plates: Array
  },
  data() {
    return {
      superShow: true,
      articles: [],
      global,
      toparticle:{},
      ttarticles:[],
      Groups: [
        {
          name: "通知公告", 
        }
      ],
    };
  },

  created() {},

  methods: {},

  computed: {},

  mounted() {
    this.$axios
      .get("/api/articles?page=1&limit=10&topnews=1&sort=-createdAt")
      .then((res) => {
        if (res.data) this.toparticle = res.data.data?res.data.data[0]:{};
        
      });
    this.$axios
      .get("/api/articles?page=1&limit=10&picnews=1&sort=-createdAt")
      .then((res) => {
        if (res.data) this.articles = this.global.sortByTop(res.data.data);
        
      });
    for (let k = 0; k < this.Groups.length; k++) {
      for (let j = 0; j < this.plates.length; j++) {
        if (this.Groups[k].name == this.plates[j].name) {
          this.Groups[k].plateId = this.plates[j]._id;
          this.$axios
            .get(
              `/api/articles?plateid=${this.Groups[k].plateId}&sort=-createdAt&limit=7`
            )
            .then((res) => {
              if (res.data) {
                this.Groups[k].articles = this.global
                  .sortByTop(res.data.data);
                this.$forceUpdate();
              }
            });
            break;
        }
      }
    }
    this.$nextTick(()=>{
            $(function () {
            $(".index-news .newsList .child:first-child").show();
            $(".titleChange .title-box .list ul li").click(function () {
                var index = $(this).index();
                console.log(index)
                $(this).addClass("active").siblings("li").removeClass("active");
                $(this).parents(".inner").find(".newsList .child:eq(" + index + ")").show().siblings(".child").hide();

            })
            $(".hotNews .pagination span").mouseover(function () {
                var index = $(this).index();
                $(this).addClass("active").siblings("span").removeClass("active");
                $(".hotNews .list ul li:eq(" + index + ")").show().siblings("li").hide();
            })
        })
        })
  },

  watch: {},
};
</script>
<style scoped>
.pictitle{
        width: 709px;
    height: 46px;
    background: #154a97;
    opacity: 0.85;
    position: fixed;
    bottom: 0px;
    color: #fff;
    font-size: 16px;
    /* text-align: end; */
    line-height: 46px;
    padding-left: 20px;
}
/deep/ .el-carousel__indicator.is-active button{
    width: 10px;
    height: 10px;
    background: #FFFFFF;
    border-radius: 50%;
}
/deep/ .el-carousel__indicator button{
  width: 10px;
    height: 10px;
    border: 1px solid #FFFFFF;
    border-radius: 50%;
}
/deep/ .el-carousel__indicators--horizontal{
    bottom: 6px;
    right: 10px;
    left:inherit;
}
.topnews{
     font-size: 29px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #1054C3;
    text-align: center;
    line-height: 45px;
    display: block;
    /* padding: 17px 0px; */
    width: 1160px;
    letter-spacing: 4px;
    margin-top: 18px;
}
.tztbiao{
  width: 91px;
	height: 0;
	border-width: 0px 43px 43px 0px;
	border-style: none solid solid;
	border-color: transparent transparent #306BCD;

}
.title-box .list li{
      font-size: 26px;
    color: #ffffff;
    line-height:43px;

}
.linebox{
  width: 471px;
    height: 2px;
    background: #306BCD;
        position: relative;
    top: 43px;
}
</style>
